<template>
<div>
</div>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'Color',
  props: {
    text: {
      type: String,
      default: 'text'
    },
    visibleoffset: {
      type: [String, Number],
      default: 600
    },
    left: {
      type: String,
      default: '15px',
    },
    bottom: {
      type: String,
      default: '0px',
    },
  },
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/color.vue